import { render, staticRenderFns } from "./CYTdetail.vue?vue&type=template&id=3863b9da&scoped=true"
import script from "./CYTdetail.vue?vue&type=script&lang=js"
export * from "./CYTdetail.vue?vue&type=script&lang=js"
import style0 from "./CYTdetail.vue?vue&type=style&index=0&id=3863b9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3863b9da",
  null
  
)

export default component.exports